exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contentContainer {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n}\r\n\r\n.decoTextContainer {\r\n    width: 40%;\r\n    margin: 5%;\r\n    word-wrap: break-word;\r\n    margin: 0;\r\n}\r\n\r\n.decoText {\r\n    font-family: 'Amatic SC';\r\n    font-size: 60px;\r\n    margin: 0;\r\n}\r\n\r\n.authorContainer{\r\n  position: fixed;\r\n  bottom: 10px;\r\n  left: 25%;\r\n}\r\nh2{\r\n  font-family: 'Cormorant SC';\r\n  font-size: 30px;\r\n}\r\nh3{\r\n  font-family: 'Cormorant SC';\r\n  font-size: 20px;\r\n}\r\n\r\n.loginContainer {\r\n    width: 40%;\r\n    margin: 5%;\r\n}\r\n\r\n.login-button {\r\n    font-family: 'Cormorant SC';\r\n    font-size: 60px;\r\n    text-align: center;\r\n    margin: -5px;\r\n    border-radius: 4px;\r\n    border: 5px solid #722f37;\r\n    background-color: white;\r\n    cursor: pointer;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.login-button:hover {\r\n    color: white;\r\n    background-color: #722f37;\r\n}\r\n\r\n.login-button:focus {\r\n    outline: 0;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.css
// module id = ./src/app/login/login.component.css
// module chunks = 1